// config/homeConfig.js

export const bestSellerIds = [
  "sbd-classic",
  "inzer-ergo-pro",
  "sbd-power",
  "muñ-sbd-classic",
  "avancus-power-v3",
  "avancus-power-high-top",
  "singlet-a7-luno-stealth",
  "nike-romaleos-4"
];
